import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class TipoDocumentacionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TipoDocumentacionViewModel[];
}

export class TipoDocumentacionViewModel {
    constructor() {}

    public Id: number;
    public IdTipoSolicitud: number | null = null;
    public IdTipoSolicitudDescripcion: string = '';
    public Descripcion: string = '';
    public DescripcionTraces: string = '';
    public RequerirTexto: boolean | null = false;
    public RequerirFecha: boolean | null = false;
    public RequerirPais: boolean | null = false;
    public AttachedTraces: boolean = false;
    public Activo: boolean = false;
}

export class FilterSearchingTipoDocumentacionViewModel extends FilterSearchingBaseViewModel {
    public IdTipoSolicitud: number | null = null;
    public Descripcion: string = '';
    public DescripcionTraces: string = '';
    public RequerirTexto: number = EnumSiNoTodos.TODOS;
    public RequerirFecha: number = EnumSiNoTodos.TODOS;
    public RequerirPais: number = EnumSiNoTodos.TODOS;
    public AttachedTraces: number = EnumSiNoTodos.TODOS;
    public Activo: number = EnumSiNoTodos.TODOS;
}
